import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_INSTITUTIONCODE_LOAD,
    ACTION_INSTITUTIONCODE_LOAD_BY_ID,
    ACTION_INSTITUTIONCODE_LOAD_BY_INSTITUTIONID,

    ACTION_INSTITUTIONCODE_SAVE,

    ACTION_INSTITUTIONCODE_CREATE,

    ACTION_INSTITUTIONCODE_VALIDATE,

    IInstitutionCodeLoadAction,
    IInstitutionCodeLoadByIdAction,
    IInstitutionCodeLoadByInstitutionIdAction,
    IInstitutionCodeLoadFailureAction,
    IInstitutionCodeLoadSuccessAction,

    IInstitutionCodeSaveAction,
    IInstitutionCodeSaveSuccessAction,
    IInstitutionCodeSaveFailureAction,

    IInstitutionCodeCreateAction,
    IInstitutionCodeCreateSuccessAction,
    IInstitutionCodeCreateFailureAction,

    IInstitutionCodeValidateAction,
    IInstitutionCodeValidateSuccessAction,
    IInstitutionCodeValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/institutionCode";
import { institutionCodesApi } from "../services/institutionCode";


export const
    getInstitutionCodesEpic = (action$): Observable<IInstitutionCodeLoadSuccessAction | IInstitutionCodeLoadFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONCODE_LOAD)
            .mergeMap((_action: IInstitutionCodeLoadAction) => {
                return institutionCodesApi
                    .getInstitutionCodes()
                    .map(response =>
                        LoadSuccess(response.institutionCodes, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getInstitutionCodeByIdEpic = (action$): Observable<IInstitutionCodeLoadSuccessAction | IInstitutionCodeLoadFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONCODE_LOAD_BY_ID)
            .mergeMap((action: IInstitutionCodeLoadByIdAction) => {
                return institutionCodesApi
                    .getInstitutionCodeById(action.id)
                    .map(response =>
                        LoadSuccess(response.institutionCode, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getInstitutionCodeByInstitutionIdEpic = (action$): Observable<IInstitutionCodeLoadSuccessAction | IInstitutionCodeLoadFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONCODE_LOAD_BY_INSTITUTIONID)
            .mergeMap((action: IInstitutionCodeLoadByInstitutionIdAction) => {
                return institutionCodesApi
                    .getInstitutionCodeByInstitutionId(action.institutionId)
                    .map(response =>
                        LoadSuccess(response.institutionCodes, undefined, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setInstitutionCodeEpic = (action$): Observable<IInstitutionCodeSaveSuccessAction | IInstitutionCodeSaveFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONCODE_SAVE)
            .mergeMap((action: IInstitutionCodeSaveAction) => {
                return institutionCodesApi
                    .setInstitutionCode(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.institutionCode, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createInstitutionCodeEpic = (action$): Observable<IInstitutionCodeCreateSuccessAction | IInstitutionCodeCreateFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONCODE_CREATE)
            .mergeMap((action: IInstitutionCodeCreateAction) => {
                return institutionCodesApi
                    .createInstitutionCode(action.institutionId)
                    .map(response =>
                        CreateSuccess(
                            response.institutionCode,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateInstitutionCodeEpic = (action$): Observable<IInstitutionCodeValidateSuccessAction | IInstitutionCodeValidateFailureAction> => {
        return action$
            .ofType(ACTION_INSTITUTIONCODE_VALIDATE)
            .mergeMap((action: IInstitutionCodeValidateAction) => {
                return institutionCodesApi
                    .validateInstitutionCode(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.institutionCode, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }



